export default __webpack_public_path__ + "big-win-bg-e2d9e86a824ac83c29e6f8ec403268e8.svg";